import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Calendar } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CTABanner = () => {
  const { language } = useLanguage();

  return (
    <section className="py-12 bg-brand-accent">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Text */}
          <div className="text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-display font-light text-brand-text mb-1">
              {language === 'en' 
                ? 'Ready to find your property in Portugal?' 
                : 'Pronto para encontrar o seu imóvel em Portugal?'
              }
            </h3>
            <p className="text-brand-text-secondary font-body text-sm md:text-base">
              {language === 'en'
                ? 'Free strategic consultation • Zero cost for the buyer'
                : 'Consulta estratégica gratuita • Custo zero para o comprador'
              }
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link 
              to="/contacto"
              className="inline-flex items-center justify-center gap-2 bg-brand-primary text-white px-6 py-3 font-body text-sm hover:bg-brand-primary-hover transition-colors whitespace-nowrap"
            >
              <Calendar className="w-4 h-4" />
              {language === 'en' ? 'Schedule Consultation' : 'Agendar Consulta'}
              <ArrowRight className="w-4 h-4" />
            </Link>
            <a 
              href="https://wa.me/351931997415"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-transparent text-brand-primary border border-brand-primary px-6 py-3 font-body text-sm hover:bg-brand-primary hover:text-white transition-colors whitespace-nowrap"
            >
              <Phone className="w-4 h-4" />
              {language === 'en' ? 'Call Now' : 'Ligar Agora'}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
